















































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { setFormatDate } from '@/modules/shared/shared/domain/functions/date-functions';
import { user } from '@/modules/shared/shared/store/namespaces';
import moment from 'moment';

@Component({})
export default class TapeDeliveryReceptionSheet extends Vue {
    date!: string;
    hour!: string;
    customerName!: string;
    contactName!: string;
    contactLastName!: string;
    contactCI!: string;
    employeeName: string = 'POR DAYCOHOST';
    ticketCode: string = 'POR DEFINIR';
    give: string = 'Entrega';
    take: string = 'Recibe';
    tapes: { isDelivered: boolean; isReceived: boolean; code: string }[] = [];

    mounted() {
        const requirementTicket: any = localStorage.getItem('requirementTicket');
        const data = JSON.parse(requirementTicket);

        if (data.generalInformation.date) {
            this.date = data.generalInformation.date;
        } else {
            this.date = new Date().toLocaleString().split(' ')[0];
        }

        if (data.generalInformation.hour) {
            this.hour = data.generalInformation.hour;
        } else {
            this.hour = moment().format('hh:mm A');
        }

        if (data.generalInformation.customerName) {
            this.customerName = data.generalInformation.customerName;
        } else {
            const customer: any = localStorage.getItem('company');
            this.customerName = JSON.parse(customer).name;
        }

        if (data.generalInformation.ticketId) {
            this.ticketCode = data.generalInformation.ticketId;
        }

        this.contactName = data.generalInformation.firstName;
        this.contactLastName = data.generalInformation.lastName;
        this.contactCI = data.generalInformation.idNumber;

        data.tapes.forEach(element => {
            if (element.giveOrTake === this.give) {
                this.tapes.push({
                    isDelivered: true,
                    isReceived: false,
                    code: element.code,
                });
            } else {
                this.tapes.push({
                    isDelivered: false,
                    isReceived: true,
                    code: element.code,
                });
            }
        });
    }
    print() {
        window.print();
    }
    @user.State('contact') contact;
}
